import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues3, LocalService, Status, TriggeredEvent, Wrapper3 } from '../../../service/local.service';

@Component({
  selector: 'app-field-config',
  templateUrl: './field-config.component.html',
  styleUrls: ['./field-config.component.scss']
})
export class FieldConfigComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["field_config"];
  id: string; countryId: string = ''; wrapper: Wrapper3; types: KeyValues3[]; maxBodyHeight = 0;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private activeModal: NgbActiveModal, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.id == '') {
      this.wrapper = {
        content: {
          key: '',
          v1: '',
          v2: this.countryId,
          v3: ''
        } as KeyValues3
      } as Wrapper3;
    }
    else {
      this.configurationManagementService.getField(this.id).subscribe(result => {
        this.wrapper = result;
      });
    }
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    this.configurationManagementService.saveField(this.wrapper).subscribe(result => {
      if (result.status == Status.Success) {
        //this.wrapper.content.key = this.id == '' ? result.id : this.id;
        // this.wrapper.content.v3 = this.wrapper.languageContents.find(x => x.key == this.localService.selected.applicationLanguage).v3;
        this.activeModal.close({ event: TriggeredEvent.Ok, wrapper: this.wrapper });
      }
    });
  }

  onEmptyLanguageContainerAdded(languageContents: any) {
    this.wrapper.languageContents = languageContents;
  }
}
